/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Header, Segment, } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
import LoadingPlaceholder from '../placeholderComponent/loadingPlaceholder';
import ApprovalActionButton from './approvalActionButton';
import AgGridTable from '../agGridComponent/agGridTable';
import Axios from 'axios';
import APP_CONSTANTS from '../../config/constants';

function ApprovalConditionTable(props) {
    const [condtionsArray, setcondtionsArray] = useState([])
    const [isLoaded, setisLoaded] = useState(false)
    const [isUpdated, setisUpdated] = useState(false)
    useEffect(() => {
        getData()
    }, [isUpdated])
    let getUpdate = (data) => {
        if (data) {
            setisUpdated(!isUpdated)
        }
    }
    let getData = () => {

        let token = localStorage.getItem('apiToken')
        let customerNo = localStorage.getItem('customerNo')
        let userId = localStorage.getItem('userId')

        let data = JSON.stringify
            ({
                api_token: token,
                customerNo: customerNo,
                userId
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/approvalcondition/getCondition`, data, {
            headers: {
                'Accept': 'application/json',
                "Authorization": token,
                'Content-Type': 'application/json'
            }
        }).then((response => {
            setcondtionsArray(response.data.data);
        }))
            .catch(error => console.log(error))


        // ReadAxios({ url: 'approvalcondition/getCondition' }).then((result) => {
        //     setcondtionsArray(result)
        //     setisLoaded(true)
        // })
    }
    /*     if (condtionsArray && condtionsArray.length === 0 && isLoaded === false) {
            return (
                <Segment id="dispatch_bar">
                    <center> <Header>NO Record(s) Found</Header></center>
                </Segment>
            )
        } else if (condtionsArray && condtionsArray.length === 0) {
            return (
                <Segment id="dispatch_bar">
                    <center> <Header>NO Record(s) Found</Header></center>
                </Segment>
            )
        } else { */

    let columnDefs = [
        { headerName: 'Jobcard Type', field: 'type', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Condition', field: 'condition', tooltipField: 'name', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Start value', field: 'svalue', tooltipField: 'cby', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'End value', field: 'evalue', tooltipField: 'cdate', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'User Role', field: 'urole', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Edit / Delete', field: 'edit', cellRenderer: 'actionRenderer' },
    ]
    let rowData = []
    condtionsArray.map((object, i) => {
        let temp = {}
        temp.type = object.jobcardType
        temp.condition = object.conditionName
        temp.svalue = object.startValue
        temp.evalue = object.endValue
        temp.id = object.jbConditionId
        temp.typeId = object.jobCardTypeId
        temp.condId = object.conditionId
        temp.urole = object.role
        temp.uroleId = object.roleId
        temp.customerNo = object.customerNo
        rowData[i] = temp
    })
    return (
        <React.Fragment >
            <AgGridTable
                columnDefs={columnDefs}
                rowData={rowData}
                searchValue={props.searchValue}
                actionButton={ApprovalActionButton}
                reload={getUpdate}
                link="/add-approval-condition"
                hiddenNewPopupBtn={true}
                titleBarTitle="Approval Condition"
                handleSearch={props.handleSearch}
            />
        </React.Fragment>
    )
}

//}

export default ApprovalConditionTable
